var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1024"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$route.params._giftcard ? _c('span', [_vm._v("배송상품 상세")]) : _c('span', [_vm._v("배송상품 등록")])]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "mx-n2 my-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "outlined": "",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v("상품 썸네일")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "mb-1 mt-0 pt-0",
    attrs: {
      "icon": "",
      "text": "",
      "hide-details": ""
    },
    on: {
      "click": _vm.removeThumb
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("mdi-minus")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('image-input', {
    attrs: {
      "aspect-ratio": 1 / 1,
      "flat": ""
    },
    model: {
      value: _vm.product.thumb,
      callback: function ($$v) {
        _vm.$set(_vm.product, "thumb", $$v);
      },
      expression: "product.thumb"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "outlined": "",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_vm._v("상품 상세이미지")]), _c('v-divider'), _c('v-card-text', [_c('images-input', {
    attrs: {
      "md": 2
    },
    model: {
      value: _vm.product.images,
      callback: function ($$v) {
        _vm.$set(_vm.product, "images", $$v);
      },
      expression: "product.images"
    }
  })], 1)], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "outlined": "",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_vm._v("상품 정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('category-delivery-select', _vm._b({
    attrs: {
      "categories": _vm.categories
    },
    model: {
      value: _vm.product._category,
      callback: function ($$v) {
        _vm.$set(_vm.product, "_category", $$v);
      },
      expression: "product._category"
    }
  }, 'category-delivery-select', Object.assign({}, _vm.attrs_input), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "진열 순서"
    },
    model: {
      value: _vm.product.no,
      callback: function ($$v) {
        _vm.$set(_vm.product, "no", $$v);
      },
      expression: "product.no"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1), _vm.isCreated ? _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "상품 코드"
    },
    model: {
      value: _vm.product.code,
      callback: function ($$v) {
        _vm.$set(_vm.product, "code", $$v);
      },
      expression: "product.code"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1) : _vm._e(), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "number",
      "label": "재고"
    },
    model: {
      value: _vm.product.stock,
      callback: function ($$v) {
        _vm.$set(_vm.product, "stock", $$v);
      },
      expression: "product.stock"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "상품명"
    },
    model: {
      value: _vm.product.name,
      callback: function ($$v) {
        _vm.$set(_vm.product, "name", $$v);
      },
      expression: "product.name"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "number",
      "label": "공급가"
    },
    model: {
      value: _vm.product.supplyPrice,
      callback: function ($$v) {
        _vm.$set(_vm.product, "supplyPrice", $$v);
      },
      expression: "product.supplyPrice"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "number",
      "label": "소비자가"
    },
    model: {
      value: _vm.product.costPrice,
      callback: function ($$v) {
        _vm.$set(_vm.product, "costPrice", $$v);
      },
      expression: "product.costPrice"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    staticClass: "amount-field text-align-right-field",
    attrs: {
      "type": "number",
      "label": "할인가"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-select', _vm._b({
          attrs: {
            "items": [{
              text: '원',
              value: 'won'
            }, {
              text: '%',
              value: 'percent'
            }],
            "dense": ""
          },
          model: {
            value: _vm.product.discountUnit,
            callback: function ($$v) {
              _vm.$set(_vm.product, "discountUnit", $$v);
            },
            expression: "product.discountUnit"
          }
        }, 'v-select', Object.assign({}, _vm.attrs_input__verticalTable), false))];
      },
      proxy: true
    }]),
    model: {
      value: _vm.product.discountAmount,
      callback: function ($$v) {
        _vm.$set(_vm.product, "discountAmount", $$v);
      },
      expression: "product.discountAmount"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "number",
      "label": "판매가",
      "readonly": ""
    },
    model: {
      value: _vm.salePrice,
      callback: function ($$v) {
        _vm.salePrice = $$v;
      },
      expression: "salePrice"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input), false))], 1)], 1)], 1), _c('v-card-text', [_c('v-divider'), _c('v-card-subtitle', [_vm._v("상품 정보")]), _c('v-divider'), _c('product-info', {
    model: {
      value: _vm.product.info,
      callback: function ($$v) {
        _vm.$set(_vm.product, "info", $$v);
      },
      expression: "product.info"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "outlined": "",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_vm._v("상품 상태")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "품절"
    },
    model: {
      value: _vm.product.soldout,
      callback: function ($$v) {
        _vm.$set(_vm.product, "soldout", $$v);
      },
      expression: "product.soldout"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "판매여부"
    },
    model: {
      value: _vm.product.onSale,
      callback: function ($$v) {
        _vm.$set(_vm.product, "onSale", $$v);
      },
      expression: "product.onSale"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "전시여부"
    },
    model: {
      value: _vm.product.onDisplay,
      callback: function ($$v) {
        _vm.$set(_vm.product, "onDisplay", $$v);
      },
      expression: "product.onDisplay"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "면세"
    },
    model: {
      value: _vm.product.isTaxFree,
      callback: function ($$v) {
        _vm.$set(_vm.product, "isTaxFree", $$v);
      },
      expression: "product.isTaxFree"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1)], 1)], 1)], 1), _c('v-card', _vm._b({
    staticClass: "mt-4",
    attrs: {
      "outlined": "",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_vm._v("상품 이벤트")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "베스트"
    },
    model: {
      value: _vm.product.isBest,
      callback: function ($$v) {
        _vm.$set(_vm.product, "isBest", $$v);
      },
      expression: "product.isBest"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "추천 상품"
    },
    model: {
      value: _vm.product.isRecommend,
      callback: function ($$v) {
        _vm.$set(_vm.product, "isRecommend", $$v);
      },
      expression: "product.isRecommend"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "신상품"
    },
    model: {
      value: _vm.product.isNewly,
      callback: function ($$v) {
        _vm.$set(_vm.product, "isNewly", $$v);
      },
      expression: "product.isNewly"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-switch', _vm._b({
    attrs: {
      "label": "인기 상품"
    },
    model: {
      value: _vm.product.isPopular,
      callback: function ($$v) {
        _vm.$set(_vm.product, "isPopular", $$v);
      },
      expression: "product.isPopular"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))], 1)], 1)], 1)], 1)], 1)], 1), _c('v-row', [_c('v-col', [_c('v-card', _vm._b({
    staticClass: "mt-4",
    attrs: {
      "outlined": "",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v("옵션상품")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mb-1 mt-0 pt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.optionalEnabled,
      callback: function ($$v) {
        _vm.optionalEnabled = $$v;
      },
      expression: "optionalEnabled"
    }
  })], 1)], 1), _c('v-divider'), _c('v-expand-transition', [_c('product-optional', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.optionalEnabled,
      expression: "optionalEnabled"
    }],
    attrs: {
      "salePrice": _vm.salePrice
    },
    model: {
      value: _vm.product.optionalProducts,
      callback: function ($$v) {
        _vm.$set(_vm.product, "optionalProducts", $$v);
      },
      expression: "product.optionalProducts"
    }
  })], 1)], 1)], 1)], 1), _c('v-row', [_c('v-col', [_c('v-card', _vm._b({
    staticClass: "mt-4",
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-subtitle', [_vm._v("상세 내용")]), _c('v-divider'), _c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.product.content,
      callback: function ($$v) {
        _vm.$set(_vm.product, "content", $$v);
      },
      expression: "product.content"
    }
  })], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }